import { motion } from 'framer-motion';
import { FiGithub, FiExternalLink } from 'react-icons/fi';

const projects = [
  {
    title: 'E-commerce Platform',
    description: 'A full-stack e-commerce platform with user authentication, product catalog, and payment integration.',
    tags: ['React', 'Node.js', 'MongoDB', 'Stripe'],
    image: null,
    bgColor: 'from-blue-600 to-purple-600',
    icon: '🛒',
    github: '#',
    demo: '#',
  },
  {
    title: 'Task Management App',
    description: 'A collaborative task management application with real-time updates and team collaboration features.',
    tags: ['React', 'Firebase', 'Tailwind CSS', 'Redux'],
    image: null,
    bgColor: 'from-green-600 to-blue-600',
    icon: '📋',
    github: '#',
    demo: '#',
  },
  {
    title: 'Weather Dashboard',
    description: 'A weather application that displays current weather and forecast using a weather API.',
    tags: ['JavaScript', 'OpenWeather API', 'CSS3', 'HTML5'],
    image: null,
    bgColor: 'from-cyan-600 to-blue-600',
    icon: '🌤️',
    github: '#',
    demo: '#',
  },
  {
    title: 'Portfolio Website',
    description: 'A personal portfolio website built with modern web technologies.',
    tags: ['React', 'TypeScript', 'Framer Motion', 'Tailwind CSS'],
    image: null,
    bgColor: 'from-purple-600 to-pink-600',
    icon: '💼',
    github: '#',
    demo: '#',
  },
];

const Projects = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
          My <span className="bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">Projects</span>
        </h2>
        <p className="text-center text-gray-400 mb-12 max-w-2xl mx-auto">
          Here are some of the projects I've worked on. Each project represents a unique challenge and learning experience.
        </p>
        
        <div className="grid md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={project.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-gray-800/50 rounded-xl overflow-hidden border border-gray-700/50 hover:border-blue-500/30 transition-all"
            >
              <div className="h-48 overflow-hidden">
                <div className={`w-full h-full bg-gradient-to-br ${project.bgColor} flex items-center justify-center hover:scale-105 transition-transform duration-500`}>
                  <div className="text-center">
                    <div className="text-6xl mb-2">{project.icon}</div>
                    <div className="text-white font-semibold text-lg">{project.title}</div>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2">{project.title}</h3>
                <p className="text-gray-400 mb-4">{project.description}</p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1 bg-gray-700/50 text-sm rounded-full text-blue-300"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="flex space-x-4">
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-gray-400 hover:text-blue-400 transition-colors"
                  >
                    <FiGithub className="mr-1" /> Code
                  </a>
                  <a
                    href={project.demo}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-gray-400 hover:text-blue-400 transition-colors"
                  >
                    <FiExternalLink className="mr-1" /> Live Demo
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <motion.a
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            href="https://github.com/Shashikant-nagal"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 border-2 border-blue-400 text-blue-400 rounded-lg font-medium hover:bg-blue-400/10 transition-colors"
          >
            <FiGithub className="mr-2" /> View More on GitHub
          </motion.a>
        </div>
      </motion.div>
    </div>
  );
};

export default Projects;
